import React from "react";
import backArrow from "../../assets/back-arrow.svg";

const BackButton = ({ text, onClick }) => {
  return (
    <div
      className="go_back flex "
      style={{ cursor: "pointer" }}
      onClick={onClick}
    >
      <img src={backArrow} alt="go back" />
      <p className="text-xs text-gray-400">{text}</p>
    </div>
  );
};

export default BackButton;
